module.exports = __webpack_public_path__ + "e0bf8f59670015ead147a302484dfc38.glb";